import { ISectionLogger } from "@multiweb/logging";
import { Event } from "Global/Base/Events";
import { ServiceWorkerMessage, ServiceWorkerMessageType } from "Global/Base/ServiceWorkerMessages";
import { ServiceWorkerResponse, ServiceWorkerResponseType } from "Global/Base/ServiceWorkerResponses";
import { OWExceptions } from "./OWExceptions";

export class ServiceWorkerConnector {
    private static _logger: ISectionLogger;
    public static readonly sessionRenewed: Event<undefined, undefined> = new Event<undefined, undefined>();

    public static init(logger: ISectionLogger): void {
        ServiceWorkerConnector._logger = logger;
        const listenerReceiver = (e: MessageEvent) => ServiceWorkerConnector._onMessage(e);
        const listenerError = (e: MessageEvent) => ServiceWorkerConnector._onError(e);

        navigator.serviceWorker.addEventListener("message", listenerReceiver);
        navigator.serviceWorker.addEventListener("messageerror", listenerError);

        window.addEventListener("unload", () => {
            navigator.serviceWorker.removeEventListener("message", listenerReceiver);
            navigator.serviceWorker.removeEventListener("messageerror", listenerError);
        });
    }

    private static _onMessage(event: MessageEvent): void {
        const message = event.data as ServiceWorkerResponse;

        if (message.type == ServiceWorkerResponseType.sessionTimeout) {
            const exc = OWExceptions.parseServiceWorkerResponse({ statusCode: message.payload.statusCode, json: message.payload.error });
            throw exc;
        } else if (message.type === ServiceWorkerResponseType.renewSession) {
            try {
                ServiceWorkerConnector.sessionRenewed.trigger(undefined, undefined);
                this.sendMessage({ type: ServiceWorkerMessageType.alive });
            } catch {
                // Prázdný catch
            }
        }
    }

    private static _onError(message: MessageEvent): void {
        ServiceWorkerConnector._logger.error("Received error", message);
    }

    public static sendMessage(message: ServiceWorkerMessage): void {
        if (!navigator.serviceWorker.controller)
            return;

        navigator.serviceWorker.controller.postMessage(message);
    }
}
